import { Center, Loader } from "@mantine/core";
import { Redirect } from "wouter";
import { usePersistHydrated } from "./_Shared/usePersistHydrated";
import { useStore } from "./store";

export function RootRedirect() {
  const hydrated = usePersistHydrated();
  const profile = useStore((state) => state.profile);

  if (!hydrated) {
    return (
      <Center py="xl">
        <Loader />
      </Center>
    );
  }
  if (profile?.role === "MarketplacePartner") return <Redirect to="/partner" />;
  if (profile?.role) return <Redirect to="/home" />;
  return <Redirect to="/auth/login" />;
}
